import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
} from '@mui/material';

/**
 * Example fields:
 *   - Maint Company ID (blue, foreign key)
 *   - Inspector ID (red, required)
 *   - Inspector Name (red, required)
 *   - Certification Number
 *   - Inspector Status
 *
 * The user can enter any combo of these fields, then click "Filter" or "Cancel."
 */
const FilterInspectorModal = ({
  open,
  handleClose,
  onApplyFilter, // a callback to the parent so we can pass back filter criteria
}) => {
  // State for each field
  const [maintCompanyId, setMaintCompanyId] = useState('');
  const [inspectorId, setInspectorId] = useState('');
  const [inspectorName, setInspectorName] = useState('');
  const [certificationNumber, setCertificationNumber] = useState('');
  const [inspectorStatus, setInspectorStatus] = useState('');

  // For Inspector Status, maybe you have a few known options:
  const inspectorStatusOptions = [
    { value: '', label: 'All' },
    { value: 'ACTIVE', label: 'Active' },
    { value: 'INACTIVE', label: 'Inactive' },
    { value: 'EXPIRED', label: 'Expired' },
  ];

  const handleCancel = () => {
    // Clear fields if you want, or leave them
    // setMaintCompanyId('');
    // setInspectorId('');
    // setInspectorName('');
    // setCertificationNumber('');
    // setInspectorStatus('');

    handleClose(); // just close the modal
  };

  const handleFilter = () => {
    // Build up a filter object
    const filterData = {
      maintCompanyId,
      inspectorId,
      inspectorName,
      certificationNumber,
      inspectorStatus,
    };

    onApplyFilter?.(filterData); 
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Filter Inspectors</DialogTitle>
      <DialogContent dividers>
        <div className="flex flex-col gap-4 mt-2">
          {/* Maint Company ID (blue, foreign key) */}
          <TextField
            label="Maint Company ID"
            variant="outlined"
            value={maintCompanyId}
            onChange={(e) => setMaintCompanyId(e.target.value)}
            fullWidth
          />

          {/* Inspector ID (red, required) */}
          <TextField
            required
            label="Inspector ID"
            variant="outlined"
            value={inspectorId}
            onChange={(e) => setInspectorId(e.target.value)}
            fullWidth
          />

          {/* Inspector Name (red, required) */}
          <TextField
            required
            label="Inspector Name"
            variant="outlined"
            value={inspectorName}
            onChange={(e) => setInspectorName(e.target.value)}
            fullWidth
          />

          {/* Certification Number */}
          <TextField
            label="Certification Number"
            variant="outlined"
            value={certificationNumber}
            onChange={(e) => setCertificationNumber(e.target.value)}
            fullWidth
          />

          {/* Inspector Status */}
          <TextField
            select
            label="Inspector Status"
            variant="outlined"
            value={inspectorStatus}
            onChange={(e) => setInspectorStatus(e.target.value)}
            fullWidth
          >
            {inspectorStatusOptions.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </TextField>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="primary" variant="outlined">
          Cancel
        </Button>
        <Button onClick={handleFilter} color="primary" variant="contained">
          Filter
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FilterInspectorModal;
